import React from "react";
import { Box, Typography } from "@mui/material";
import { LabAttachment as LabAttachmentType } from "../../../interfaces/LabInterfaces";
import { isImage, isPDF } from "../../../helpers/files";

interface LabAttachmentProps {
  attachment: LabAttachmentType;
  maxHeight?: string | number;
}

// eslint-disable-next-line import/prefer-default-export
export function LabAttachmentPrint({ attachment, maxHeight }: LabAttachmentProps): React.ReactNode {
  const fileName = attachment?.fileName || "";
  const fileIsPDF = isPDF(fileName);
  const fileIsImage = isImage(fileName);

  if (fileIsPDF) {
    return (
      <Box
        sx={{
          width: "100%",
          height: maxHeight || "26cm",
          display: "flex",
          flexDirection: "column",
          mb: 4,
          pageBreakInside: "avoid",
          pageBreakAfter: "always"
        }}
      >
        <iframe
          src={`${attachment.s3ResourceURL}#toolbar=0&navpanes=0&scrollbar=0`}
          title={fileName}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            borderRadius: "4px"
          }}
        />
      </Box>
    );
  }

  if (fileIsImage) {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mb: 4,
          pageBreakInside: "avoid",
          pageBreakAfter: "always"
        }}
      >
        <img
          src={attachment.s3ResourceURL}
          alt={fileName}
          style={{
            maxWidth: "100%",
            height: "auto",
            maxHeight: maxHeight || "27cm",
            display: "block",
            borderRadius: "4px"
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, border: "1px solid #ddd", borderRadius: 1, mb: 2, pageBreakInside: "avoid" }}>
      <Typography variant="body2" color="error">
        Unsupported attachment type: {fileName}
      </Typography>
      <Typography variant="caption" display="block" sx={{ mt: 1 }}>
        Please view this attachment in the digital report.
      </Typography>
    </Box>
  );
}
